export enum PageTab {
  Individual = 'individual',
  Company = 'company',
  Teams = 'teams'
}
